import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {noop} from '@Utils/general.util';
import {ClickableDiv} from '@Components/clickable-div';
import styles from './logo-with-back-btn.module.scss';

interface LogoWithBackBtnProps {
  onBack: VoidFunction;
  onLogoClick: VoidFunction;
  isMobileLogo?: boolean;
  disableBackButton?: boolean;
  hideBackButton?: boolean;
}

export function LogoWithBackBtn({onBack = noop, onLogoClick = noop, isMobileLogo = false, disableBackButton = false, hideBackButton = false}: LogoWithBackBtnProps): ReactElement<any> {
  const getLogoURL = (): string => {
    if (!isMobileLogo) {
      return window.PMW.util.asset_url('images/logo-postermaker.svg');
    }

    return window.PMW.util.asset_url('images/logo-mobile.svg');
  };

  const getBackButtonIcon = (): ReactElement<any> | null => {
    return (
      <Icon
        onClick={onBack}
        icon="icon-back"
        size={IconSize.SIZE_ICON_20}
        isDisabled={disableBackButton}
        shape={IconShape.SQUARE}
        type={IconType.DARK_GHOST}
        className={`spacing-m-r-2 ${hideBackButton ? '_hidden' : ''}`}
      />
    );
  };

  return (
    <div className="flex-h-row flex-center">
      {getBackButtonIcon()}
      <ClickableDiv
        onClick={onLogoClick}
        className={`_cursor-pointer flex-center ${styles.imageContainerWeb} ${!isMobileLogo ? styles.imageContainerWeb : styles.imageContainerMobile}`}
      >
        <img className={`${styles.logo} ${!isMobileLogo ? styles.logo : styles.logoWidthMobile}`} src={getLogoURL()} alt={window.i18next.t('pmwjs_logo')} />
      </ClickableDiv>
    </div>
  );
}
